export const SocketURL: string = "https://api.raztechnologies.co.ke/";